import Akari from './Akari';

export default function App() {
  return <Akari />;
}
